var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 153,
    viewBox: "0 0 152 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_1013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76 0C34.0934 0 0 34.3177 0 76.5C0 118.682 34.0934 153 76 153C117.907 153 152 118.682 152 76.5C152 34.3177 117.907 0 76 0ZM76 144.247C38.8879 144.247 8.69532 113.856 8.69532 76.5C8.69532 39.1442 38.8879 8.75253 76 8.75253C113.112 8.75253 143.305 39.1442 143.305 76.5C143.305 113.856 113.112 144.247 76 144.247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2617 58.8943C51.8604 58.8943 49.9141 60.8534 49.9141 63.2706V99.4545C49.9141 101.872 51.8604 103.831 54.2617 103.831C56.6631 103.831 58.6094 101.872 58.6094 99.4545V63.2706C58.6094 60.8534 56.6631 58.8943 54.2617 58.8943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2617 38.4702C53.1168 38.4702 51.9961 38.937 51.1894 39.7539C50.3778 40.566 49.9141 41.6941 49.9141 42.8465C49.9141 43.9989 50.3778 45.1265 51.1894 45.9439C51.9961 46.7559 53.1168 47.2227 54.2617 47.2227C55.4066 47.2227 56.5273 46.7559 57.3341 45.9439C58.1456 45.1265 58.6094 43.9989 58.6094 42.8465C58.6094 41.6941 58.1456 40.566 57.3341 39.7539C56.5273 38.937 55.4066 38.4702 54.2617 38.4702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8207 62.298C87.2701 62.298 83.0582 63.7743 79.6231 66.2702V63.2706C79.6231 60.8534 77.6768 58.8943 75.2754 58.8943C72.874 58.8943 70.9277 60.8534 70.9277 63.2706V99.4545C70.9277 101.872 72.874 103.831 75.2754 103.831C77.6768 103.831 79.6231 101.872 79.6231 99.4545V83.3284C79.6231 76.5583 85.0948 71.0506 91.8207 71.0506C98.5465 71.0506 104.018 76.5583 104.018 83.3284V100.427C104.018 102.844 105.965 104.803 108.366 104.803C110.767 104.803 112.714 102.844 112.714 100.427V83.3284C112.714 71.7323 103.341 62.298 91.8207 62.298Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_1013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 153,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.8ff65718ea0d77bf2f8e5072b1643b30.svg";
export { ForwardRef as ReactComponent };